import { theme } from '@zappyrent/hundop';
import { isEmpty } from 'lodash';
import PhoneInput from 'react-phone-input-2';

import { StyledLabel, StyledWrapper } from './TelephoneInput.styles';
import { ITelephoneInputProps } from './TelephoneInput.types';
import 'react-phone-input-2/lib/plain.css';

const TelephoneInput = ({
  id,
  name,
  label,
  value,
  disabled,
  children,
  required,
  onChange,
}: ITelephoneInputProps): JSX.Element => {
  const phoneInputStyles = {
    width: '100%',
    paddingTop: '0.6rem',
    paddingBottom: '0.6rem',
    border: 'none',
    background: 'transparent',
    borderBottom: `1px solid ${
      disabled ? 'transparent' : theme.colors.cross.silverFox
    }`,
    transition: 'all 0.5s ease',
  };

  const buttonStyle = {
    border: 'none',
    background: 'transparent',
  };

  return (
    <StyledWrapper isActive={true} isEmpty={isEmpty(value)} inputValue={value}>
      {label && (
        <StyledLabel htmlFor={id} required={required}>
          {label}
        </StyledLabel>
      )}
      <PhoneInput
        country={'it'}
        disabled={disabled}
        inputStyle={phoneInputStyles}
        buttonStyle={buttonStyle}
        value={value}
        enableSearch={false}
        onChange={(_, __, ___, formattedValue) => {
          onChange && onChange(formattedValue);
        }}
        placeholder=""
        inputProps={{
          id,
          name,
        }}
      />
      {children}
    </StyledWrapper>
  );
};

export default TelephoneInput;
